<template>
    <mini-curriculum></mini-curriculum>
</template>

<script>
import MiniCurriculum from './MiniCurriculum'

export default {
    components: {
        MiniCurriculum,
    },
}
</script>
